import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Linkedin } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-charcoal-deep border-t border-white/10 mt-32" data-testid="site-footer">
      <div className="max-w-[1480px] mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <p className="font-serif text-2xl text-cream leading-tight brand-underline">
            Huis aan de Costa del Sol
          </p>
          <p
            className="text-[0.6rem] tracking-[0.28em] uppercase text-cream-muted mt-2"
            style={{ lineHeight: 1.4 }}
          >
            by NM Luxury Estates
          </p>
          <p className="text-cream-muted text-sm mt-6 leading-relaxed">
            {t.footer.tagline}
          </p>
        </div>

        <div>
          <p className="overline mb-5">{t.contact.officeTitle}</p>
          <p className="text-cream text-sm font-light leading-relaxed">
            NM Luxury Estates<br />
            Vista Bahia 2/40<br />
            29690 Casares del Sol<br />
            Spanje
          </p>
        </div>

        <div>
          <p className="overline mb-5">Contact</p>
          <p className="text-cream text-sm font-light leading-relaxed">
            <a href="tel:+34604134186" className="hover:text-gold transition-colors block" data-testid="footer-phone-michael">
              Michael: +34 604 134 186
            </a>
            <a href="tel:+34613905797" className="hover:text-gold transition-colors block mt-1" data-testid="footer-phone-nancy">
              Nancy: +34 613 905 797
            </a>
            <a href="mailto:michael@nmluxuryestates.com" className="hover:text-gold transition-colors block mt-3 break-all" data-testid="footer-email-michael">
              michael@nmluxuryestates.com
            </a>
            <a href="mailto:nancy@nmluxuryestates.com" className="hover:text-gold transition-colors block mt-1 break-all" data-testid="footer-email-nancy">
              nancy@nmluxuryestates.com
            </a>
          </p>
        </div>

        <div>
          <p className="overline mb-5">{t.footer.followUs}</p>
          <div className="flex gap-4">
            <a href="https://instagram.com/@nm_luxuryhomes" target="_blank" rel="noreferrer" className="text-cream-muted hover:text-gold transition-colors" data-testid="footer-instagram">
              <Instagram size={20} strokeWidth={1.25} />
            </a>
            <a href="https://facebook.com/Hannes-Smulder-Nancy%20Michael" target="_blank" rel="noreferrer" className="text-cream-muted hover:text-gold transition-colors" data-testid="footer-facebook">
              <Facebook size={20} strokeWidth={1.25} />
            </a>
            <a href="https://youtube.com/@michaelkeithhannes8776" target="_blank" rel="noreferrer" className="text-cream-muted hover:text-gold transition-colors" data-testid="footer-youtube">
              <Youtube size={20} strokeWidth={1.25} />
            </a>
            <a href="https://linkedin.com/" target="_blank" rel="noreferrer" className="text-cream-muted hover:text-gold transition-colors" data-testid="footer-linkedin">
              <Linkedin size={20} strokeWidth={1.25} />
            </a>
          </div>
          <div className="mt-8 space-y-2">
            <Link to="/contact" className="block text-cream-muted hover:text-gold transition-colors text-sm" data-testid="footer-contact-link">
              {t.nav.contact}
            </Link>
            <Link to="/diensten" className="block text-cream-muted hover:text-gold transition-colors text-sm" data-testid="footer-services-link">
              {t.nav.services}
            </Link>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1480px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-cream-subtle text-xs">
            © {year} NM Luxury Estates. {t.footer.rights}
          </p>
          <p className="text-cream-subtle text-xs text-center md:text-right">
            Marbella · Estepona · Sotogrande · Benahavís · Torremolinos · Mijas · Fuengirola
          </p>
        </div>
      </div>
    </footer>
  );
}
